<template>
  <div class="view-contractors-employees">
    <app-content-title
      :title="contractor ? contractor.name : ''"
      :link-to="linkTo"
      :link-text="linkText"
    >
    </app-content-title>

    <div class="view-contractors-employees__header">
      <app-button-control
        class="view-contractors-employees__header-btn"
        type="secondary"
        @click="isOpenEmployeeAdd"
      >
        + Добавить сотрудника
      </app-button-control>
    </div>

    <employees-table
      v-if="!isLoading && employeesList.length"
      @open-edit="isOpenEmployeeEdit"
      @make-signer="innerMakeSigner"
      :response="employeesList"
    ></employees-table>

    <app-empty-data
      title="Нет Сотрудников"
      description="Добавьте сотрудников"
      v-else-if="!isLoading"
    >
      <template #footer>
        <app-button-control
          class="app-empty-data__btn"
          type="secondary"
          @click="isOpenEmployeeAdd"
        >
          добавить сотрудника
        </app-button-control>
      </template>
    </app-empty-data>

    <employee-curtain
      :uuid="uuidEmployee"
      :id="contractorId"
      :employee="currentEmployee"
      :isEdit="isEdit"
      :isPortal="isEmployeeForm"
      :employeesLength="employeesList.length"
      v-if="isEmployeeForm"
      :typeContractor="contractor.type"
      @update="asyncData()"
      @loading="isLoading = $event"
    ></employee-curtain>

    <app-loader v-if="isLoading" isCircle isAbsolute></app-loader>
  </div>
</template>

<script>
import { rootMapper } from '@/store/root';
import { contractorsMapper } from '@/store/contractors';
import { CONTRACTORS } from '@/helpers/enums/menus';

export default {
  name: 'ViewContractorsEmployees',
  inject: ['responsive'],
  components: {
    AppEmptyData: () => import('@/components/common/AppEmptyData'),
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
    AppLoader: () => import('@/components/ui/AppLoader'),
    EmployeesTable: () =>
      import('@/pages/contractors/components/employees-table/EmployeesTable'),
    EmployeeCurtain: () =>
      import('@/pages/contractors/components/EmployeeCurtain'),
    AppContentTitle: () => import('@/components/common/AppContentTitle'),
  },
  data: () => ({
    isLoading: false,
    isEmployeeForm: false,
    isEdit: false,
    uuidEmployee: '',
    employeesList: [],
    currentEmployee: {},
    contractor: null,
    linkTo: CONTRACTORS.route,
    linkText: 'Вернуться к организациям',
  }),
  computed: {
    ...contractorsMapper.mapGetters(['contractorsList']),
    ...rootMapper.mapState(['isOpenedCurtain']),
    contractorId() {
      return +this.$route.params.id;
    },
  },
  watch: {
    isOpenedCurtain(value) {
      if (!value) {
        this.isEmployeeForm = false;
        this.currentEmployee = {};
      }
    },
  },
  created() {
    this.asyncData();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === 'profile.index') {
        // eslint-disable-next-line no-param-reassign
        vm.linkTo = from.fullPath;
        // eslint-disable-next-line no-param-reassign
        vm.linkText = 'Вернуться в профиль';
      }
    });
  },
  methods: {
    ...contractorsMapper.mapActions(['getContractor', 'makeSigner']),
    /**
     * Загрузка данныx по контрагенту
     */
    async asyncData() {
      try {
        this.isLoading = true;
        this.contractor = await this.getContractor(this.contractorId);
        this.employeesList = this.contractor.employees;
      } catch {
        // -
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * Установить сотрудника подписантом
     * @param {String} uuid - uuid сотрудника
     */
    async innerMakeSigner(uuid) {
      try {
        await this.makeSigner({ id: this.contractorId, uuid });
        this.employeesList.forEach((el) => {
          // eslint-disable-next-line no-param-reassign
          el.isSigner = el.uuid === uuid;
        });
      } catch {
        // -
      }
    },
    /**
     * Открытие шторки редакирования сотрудника
     * @param {String} uuid - uuid сотрудника
     */
    isOpenEmployeeEdit(uuid) {
      this.uuidEmployee = uuid;
      this.currentEmployee = this.employeesList.find((el) => el.uuid === uuid);
      this.isEdit = true;
      this.isEmployeeForm = true;
      this.$modal.show('main-curtain');
    },
    /**
     * Открытие шторки добавления сотрудника
     */
    isOpenEmployeeAdd() {
      this.isEdit = false;
      this.isEmployeeForm = true;
      this.$modal.show('main-curtain');
    },
  },
};
</script>

<style lang="scss" scoped>
.view-contractors-employees {
  &__header {
    margin-bottom: 30px;
  }

  &__header-btn {
    height: 35px;
    margin-right: 24px;
    font-weight: normal;
    text-transform: none;
  }
}
</style>
